// Translations dictionary for FR/EN
export const translations = {
  fr: {
    brand: "PANCRACE BOONGO JR.",
    role: "Économiste • Entrepreneur",
    nav: {
      apropos: "À Propos",
      parcours: "Parcours",
      expertise: "Expertise",
      atouts: "Aptitudes",
      contact: "Contact",
    },
    about: {
      overline: "À Propos de PB JR.",
      paragraphs: [
        "Pancrace BOONGO JR. est un économiste diplômé de l’Université d’Ottawa (Canada), établi à Kinshasa, en République Démocratique du Congo.",
        "Son parcours combine des expériences acquises au sein d’institutions publiques, de l’administration gouvernementale et du secteur entrepreneurial. Au fil des années, il a collaboré avec divers acteurs du développement et de la gouvernance publique.",
        "Animé par un profond intérêt pour le développement économique, la modernisation institutionnelle et l’amélioration de l’action publique, il s’attache à promouvoir des approches innovantes au service de l’efficacité administrative et du progrès collectif.",
        "À travers ses engagements professionnels, il contribue au renforcement des capacités institutionnelles et à la modernisation de l’action publique en République Démocratique du Congo.",
      ],
      monogramRole: "Économiste",
      monogramPlace: "Kinshasa · RDC",
    },
    parcours: {
      overline: "Parcours",
      title: "Un parcours au croisement du public, du privé et du social.",
      intro:
        "Au cours de son parcours professionnel, Pancrace BOONGO JR. a évolué au sein d’institutions publiques, d’organisations de la société civile et d’initiatives entrepreneuriales. Ces expériences lui ont permis de développer une compréhension approfondie des enjeux liés à la gouvernance, aux finances publiques, au développement économique et à la gestion des organisations.",
      cards: {
        institutions: {
          overline: "01 — Secteur public",
          title: "Institutions publiques",
          items: [
            "Assistant Parlementaire — Sénat de la République (3ᵉ législature)",
            "Cabinet du Ministre de l’Aménagement du Territoire",
            "Cabinet du Questeur — Sénat de la République (4ᵉ législature)",
            "Expert Rédacteur — Comité Interministériel des Droits de l’Homme de la République",
            "Cabinet du Ministre des Droits Humains",
            "Cabinet du Ministre des Finances",
            "Direction Générale des Impôts (DGI)",
          ],
        },
        entrepreneuriat: {
          overline: "02 — Secteur privé",
          title: "Entrepreneuriat",
          description:
            "Empire_Investment — entreprise multisectorielle active dans le numérique, l’agriculture et les solutions d’investissement.",
          items: ["Empire_Investment"],
        },
        engagement: {
          overline: "03 — Société civile",
          title: "Engagement associatif",
          description:
            "NOGÉDÉD ASBL — organisation à but non lucratif fondée à l’initiative de Pancrace BOONGO JR., née dans le territoire de Djolu (Tshuapa) et dédiée au développement communautaire, à l’éducation, à l’agriculture et à l’autonomisation de la jeunesse. Reconnue comme partenaire du Ministère de l’Agriculture et Sécurité Alimentaire de la République Démocratique du Congo par l’Arrêté ministériel n° 023/CAB/MIN/AGRISA/MNB/LMM/2025 du 15 décembre 2025.",
        },
      },
    },
    expertise: {
      overline: "Expertise",
      title: "Une expertise multidisciplinaire, ancrée dans l’action publique.",
      intro:
        "Au croisement de l’économie, de la gouvernance publique et de l’entrepreneuriat, Pancrace BOONGO JR. a développé une expertise multidisciplinaire fondée sur une formation académique rigoureuse et une expérience acquise au sein d’institutions publiques, d’organisations de la société civile et d’initiatives privées.",
      items: [
        {
          title: "Économie & Analyse économique",
          text: "Analyse des dynamiques économiques, évaluation des politiques publiques et compréhension des mécanismes de développement.",
        },
        {
          title: "Finances publiques & Fiscalité",
          text: "Mobilisation des recettes, gestion des ressources publiques et gouvernance financière.",
        },
        {
          title: "Gouvernance & Administration publique",
          text: "Organisation institutionnelle, gestion administrative et amélioration de la performance publique.",
        },
        {
          title: "Gestion de projets & Développement",
          text: "Conception, coordination et accompagnement d’initiatives à vocation économique, sociale et institutionnelle.",
        },
        {
          title: "Développement communautaire",
          text: "Promotion de l’éducation, de l’agriculture, de la jeunesse et des initiatives favorisant le développement local.",
        },
        {
          title: "Transformation numérique & Innovation",
          text: "Intégration des technologies numériques au service de la modernisation des organisations et des processus administratifs.",
        },
      ],
    },
    atouts: {
      overline: "Aptitudes professionnelles",
      title: "Compétences avérées dans des environnements exigeants.",
      intro:
        "Au fil de son parcours, Pancrace BOONGO JR. a développé un ensemble d’aptitudes professionnelles qui lui permettent d’évoluer efficacement dans des environnements exigeants, multidisciplinaires et en constante évolution.",
      cards: {
        communication: {
          title: "Communication & Langues",
          description:
            "Capacité à évoluer dans des environnements professionnels multilingues et multiculturels.",
          items: ["Français", "Anglais", "Lingala"],
        },
        leadership: {
          title: "Leadership & Gestion",
          description:
            "Capacité à coordonner des équipes, conduire des initiatives et accompagner le développement d’organisations et de projets.",
          items: [
            "Coordination d’équipes",
            "Gestion organisationnelle",
            "Développement institutionnel",
            "Conduite de projets",
          ],
        },
        analyse: {
          title: "Analyse & Stratégie",
          description:
            "Approche fondée sur l’analyse, la réflexion stratégique et l’orientation vers les résultats.",
          items: [
            "Analyse économique",
            "Planification stratégique",
            "Aide à la décision",
            "Résolution de problèmes",
          ],
        },
      },
    },
    contact: {
      overline: "Contact",
      title: "Entrer en contact.",
      intro:
        "Pour toute proposition ou prise de contact, prière de laisser un message ci-dessous. Merci.",
      labels: {
        name: "Nom complet",
        email: "Adresse électronique",
        message: "Message",
      },
      placeholders: {
        name: "Votre nom",
        email: "vous@exemple.com",
        message: "Votre message",
      },
      submit: "Envoyer",
      submitting: "Envoi en cours…",
      success: {
        title: "Votre message a été transmis avec succès.",
        subtitle: "Merci pour votre prise de contact.",
        another: "Envoyer un autre message",
      },
      errors: {
        empty: "Veuillez remplir tous les champs.",
        generic: "Une erreur est survenue. Veuillez réessayer.",
      },
      toastSuccess: "Message transmis avec succès.",
    },
    quote: {
      text: "Tout ce que l’esprit de l’homme peut concevoir et croire, il peut le réaliser.",
      author: "Napoleon Hill",
    },
    footer:
      "© 2026 Pancrace BOONGO JR. — Kinshasa, République Démocratique du Congo",
  },
  en: {
    brand: "PANCRACE BOONGO JR.",
    role: "Economist • Entrepreneur",
    nav: {
      apropos: "About",
      parcours: "Career",
      expertise: "Expertise",
      atouts: "Strengths",
      contact: "Contact",
    },
    about: {
      overline: "About PB JR.",
      paragraphs: [
        "Pancrace BOONGO JR. is an economist, a graduate of the University of Ottawa (Canada), based in Kinshasa, the Democratic Republic of the Congo.",
        "His career combines experiences within public institutions, government administration and the entrepreneurial sector. Over the years, he has collaborated with various stakeholders in development and public governance.",
        "Driven by a deep interest in economic development, institutional modernisation and the improvement of public administration, he is committed to promoting innovative approaches that serve administrative efficiency and collective progress.",
        "Through his professional engagements, he contributes to strengthening institutional capacities and to the modernisation of public administration in the Democratic Republic of the Congo.",
      ],
      monogramRole: "Economist",
      monogramPlace: "Kinshasa · DRC",
    },
    parcours: {
      overline: "Career",
      title: "A career at the crossroads of the public, private and social sectors.",
      intro:
        "Throughout his professional career, Pancrace BOONGO JR. has worked within public institutions, civil society organisations and entrepreneurial initiatives. These experiences have allowed him to develop a deep understanding of governance, public finance, economic development and organisational management.",
      cards: {
        institutions: {
          overline: "01 — Public sector",
          title: "Public institutions",
          items: [
            "Parliamentary Assistant — Senate of the Republic (3rd Legislature)",
            "Office of the Minister of Land Planning",
            "Office of the Quaestor — Senate of the Republic (4th Legislature)",
            "Expert Drafter — Inter-Ministerial Committee for Human Rights of the Republic",
            "Office of the Minister of Human Rights",
            "Office of the Minister of Finance",
            "General Directorate of Taxes (DGI)",
          ],
        },
        entrepreneuriat: {
          overline: "02 — Private sector",
          title: "Entrepreneurship",
          description:
            "Empire_Investment — a multi-sector company active in digital services, agriculture and investment solutions.",
          items: ["Empire_Investment"],
        },
        engagement: {
          overline: "03 — Civil society",
          title: "Community engagement",
          description:
            "NOGÉDÉD ASBL — a non-profit organisation founded on the initiative of Pancrace BOONGO JR., born in the territory of Djolu (Tshuapa) and dedicated to community development, education, agriculture and youth empowerment. Recognised as a partner of the Ministry of Agriculture and Food Security of the Democratic Republic of the Congo by Ministerial Order No. 023/CAB/MIN/AGRISA/MNB/LMM/2025 of 15 December 2025.",
        },
      },
    },
    expertise: {
      overline: "Expertise",
      title: "Multidisciplinary expertise, rooted in public service.",
      intro:
        "At the crossroads of economics, public governance and entrepreneurship, Pancrace BOONGO JR. has developed multidisciplinary expertise grounded in rigorous academic training and experience gained within public institutions, civil society organisations and private initiatives.",
      items: [
        {
          title: "Economics & Economic Analysis",
          text: "Analysis of economic dynamics, evaluation of public policies and understanding of development mechanisms.",
        },
        {
          title: "Public Finance & Taxation",
          text: "Revenue mobilisation, public resource management and financial governance.",
        },
        {
          title: "Governance & Public Administration",
          text: "Institutional organisation, administrative management and improvement of public sector performance.",
        },
        {
          title: "Project Management & Development",
          text: "Design, coordination and support of initiatives with economic, social and institutional purposes.",
        },
        {
          title: "Community Development",
          text: "Promotion of education, agriculture, youth and initiatives fostering local development.",
        },
        {
          title: "Digital Transformation & Innovation",
          text: "Integration of digital technologies to modernise organisations and administrative processes.",
        },
      ],
    },
    atouts: {
      overline: "Professional strengths",
      title: "Proven strengths in demanding environments.",
      intro:
        "Throughout his career, Pancrace BOONGO JR. has developed a set of professional strengths that allow him to operate effectively in demanding, multidisciplinary and constantly evolving environments.",
      cards: {
        communication: {
          title: "Communication & Languages",
          description:
            "Ability to operate in multilingual and multicultural professional environments.",
          items: ["French", "English", "Lingala"],
        },
        leadership: {
          title: "Leadership & Management",
          description:
            "Ability to coordinate teams, lead initiatives and support the development of organisations and projects.",
          items: [
            "Team coordination",
            "Organisational management",
            "Institutional development",
            "Project leadership",
          ],
        },
        analyse: {
          title: "Analysis & Strategy",
          description:
            "An approach grounded in analysis, strategic thinking and a results-oriented mindset.",
          items: [
            "Economic analysis",
            "Strategic planning",
            "Decision support",
            "Problem solving",
          ],
        },
      },
    },
    contact: {
      overline: "Contact",
      title: "Get in touch.",
      intro:
        "For any proposal or enquiry, please leave a message below. Thank you.",
      labels: {
        name: "Full name",
        email: "Email address",
        message: "Message",
      },
      placeholders: {
        name: "Your name",
        email: "you@example.com",
        message: "Your message",
      },
      submit: "Send",
      submitting: "Sending…",
      success: {
        title: "Your message has been successfully sent.",
        subtitle: "Thank you for reaching out.",
        another: "Send another message",
      },
      errors: {
        empty: "Please fill in all fields.",
        generic: "An error occurred. Please try again.",
      },
      toastSuccess: "Message successfully sent.",
    },
    quote: {
      text: "Whatever the mind of man can conceive and believe, it can achieve.",
      author: "Napoleon Hill",
    },
    footer:
      "© 2026 Pancrace BOONGO JR. — Kinshasa, Democratic Republic of the Congo",
  },
};
